// Forwards the signed-in user's token to the AI proxy functions so founder
// quotas can be enforced server-side (see functions/api/_quota.ts).
import { supabase } from '../config/supabase';

export async function gathrxrAuthHeader(): Promise<Record<string, string>> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    return session?.access_token ? { 'x-gathrxr-token': session.access_token } : {};
  } catch {
    return {};
  }
}
